var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Body } from "@irati/ui/src/Typography";
import Flex from "@irati/ui/src/Flex";
var Img = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: ", ";\n  width: 100px;\n"], ["\n  padding-bottom: ", ";\n  width: 100px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.three;
});
var DefaultDescription = function (_a) {
    var description = _a.description;
    return React.createElement(Body, null, description);
};
var Empty = function (_a) {
    var _b = _a.description, description = _b === void 0 ? "" : _b, src = _a.src, alt = _a.alt, _c = _a.renderDescription, renderDescription = _c === void 0 ? DefaultDescription : _c;
    return (React.createElement(Flex, { direction: "column", justifyContent: "flex-start" },
        React.createElement(Img, { src: src, alt: alt }),
        renderDescription({ description: description })));
};
export default Empty;
var templateObject_1;
